import { makeMed5 } from './textStyles';
const sidebarItem = {
    pt: '12px',
    textAlign: 'center',
    w: '68px',
    h: '72px',
};
const vstackStyles = (tokens) => ({
    variants: {
        sidebar: {
            height: '100%',
            color: 'white',
            w: '68px',
            bgColor: tokens.PrimaryNavigationWebBgFillUnselected,
            pt: '100px',
            zIndex: 3,
            boxShadow: '4px 0px 6px 0px rgba(26,26,26,0.2)',
            position: 'fixed',
        },
        'sidebar-item-selected': makeMed5(tokens, {
            ...sidebarItem,
            bgColor: tokens.PrimaryNavigationWebBgFillSelected,
            position: 'relative',
            _after: {
                content: '""',
                position: 'absolute',
                top: '4%',
                right: 0,
                w: '3px',
                h: '92%',
                bgColor: tokens.PrimaryNavigationWebBgFillUnselected,
            },
        }),
        'sidebar-item-unselected': makeMed5(tokens, {
            ...sidebarItem,
            bgColor: tokens.PrimaryNavigationWebBgFillUnselected,
        }),
        formColumn: {
            bgColor: 'red',
        },
        formRow: {
            bgColor: 'yellow',
        },
    },
});
export default vstackStyles;
